export default function Footer() {
  return <footer id="footer">© Copyright, Kee-Fung Anthony Ho, 2023</footer>;
}
